import { render } from "./WCImage.vue?vue&type=template&id=b986879c&scoped=true"
import script from "./WCImage.vue?vue&type=script&lang=js"
export * from "./WCImage.vue?vue&type=script&lang=js"

import "./WCImage.vue?vue&type=style&index=0&id=b986879c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b986879c"]])

export default __exports__